var React = require('react');

function SmilePurpleIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.9875 0.5C6.0875 0.5 0.5 6.1 0.5 13C0.5 19.9 6.0875 25.5 12.9875 25.5C19.9 25.5 25.5 19.9 25.5 13C25.5 6.1 19.9 0.5 12.9875 0.5ZM13 23C7.475 23 3 18.525 3 13C3 7.475 7.475 3 13 3C18.525 3 23 7.475 23 13C23 18.525 18.525 23 13 23ZM19.25 9.875C19.25 10.9125 18.4125 11.75 17.375 11.75C16.3375 11.75 15.5 10.9125 15.5 9.875C15.5 8.8375 16.3375 8 17.375 8C18.4125 8 19.25 8.8375 19.25 9.875ZM8.625 11.75C9.6625 11.75 10.5 10.9125 10.5 9.875C10.5 8.8375 9.6625 8 8.625 8C7.5875 8 6.75 8.8375 6.75 9.875C6.75 10.9125 7.5875 11.75 8.625 11.75ZM19.3875 15.5C18.3875 18.05 15.9125 19.875 13 19.875C10.0875 19.875 7.6125 18.05 6.6125 15.5H19.3875Z","fill":"#3D278A"}));
}

SmilePurpleIcon.defaultProps = {"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none"};

module.exports = SmilePurpleIcon;

SmilePurpleIcon.default = SmilePurpleIcon;
